import { fleetApiHttp } from '@/services/api/tattle-http'
import type { TicketTimeline } from './ticket-timeline.types'

export const TicketTimelineApi = {
  async getTimeline(key: string) {
    const response = await fleetApiHttp.get<TicketTimeline>(`/timeline/${encodeURIComponent(key)}`)
    return response.data
  }
}
